import React from "react";
import {
	List,
	Datagrid,
	BooleanField,
	TextField,
	EditButton,
	ReferenceField,
	ChipField,
	Filter,
	TextInput,
	ReferenceArrayInput,
	SelectArrayInput
} from "react-admin";
import { SUPERADMIN } from "../../constant/TypeRole";
import Actions from "../Actions";
const TypeFilter = props => {
	const role = localStorage.getItem("role");
	const project = JSON.parse(localStorage.getItem("project"));
	const filter = role ? (role === SUPERADMIN ? {} : { _id: project }) : {};
	return (
		<Filter {...props}>
			<TextInput source="name_contains" />
			<ReferenceArrayInput
				alwaysOn
				style={{ minWidth: "200px" }}
				source="project"
				reference="project"
				filter={filter}
			>
				<SelectArrayInput optionText="name" />
			</ReferenceArrayInput>
		</Filter>
	);
};

export const TypeList = props => {
	const {
		options: { label }
	} = props;
	const role = localStorage.getItem("role");
	const project = JSON.parse(localStorage.getItem("project"));
	const filter = role ? (role === SUPERADMIN ? {} : { project }) : { project };
	return (
		<List
			{...props}
			title={`${label}`}
			bulkActions={false}
			actions={<Actions create />}
			filters={<TypeFilter />}
			filterDefaultValues={filter}
			sort={{ field: "name", order: "ASC" }}
		>
			<Datagrid>
				<div />
				<TextField source="name" />
				<ReferenceField source="project" reference="project" linkType={false}>
					<ChipField source="name" />
				</ReferenceField>
				<TextField source="order" />
				<BooleanField source="visible" label="แสดงรายการนี้"/>
				<EditButton />
			</Datagrid>
		</List>
	);
};



// WEBPACK FOOTER //
// ./src/components/type/TypeList.js